import { Injectable } from '@angular/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

@Injectable({ providedIn: 'root' })
export class AppStatusBarService {
    private readonly BRAND_BLUE = '#092875';

    /**
     * Da chiamare una sola volta all’avvio app
     * Risultato desiderato: status bar BLU con icone BIANCHE
     */
    async init(): Promise<void> {
        if (Capacitor.getPlatform() === 'android') {
            // Per una status bar “classica” e colorata NON usiamo overlay
            await StatusBar.setOverlaysWebView({ overlay: false });
            await StatusBar.setBackgroundColor({ color: this.BRAND_BLUE });
            await StatusBar.setStyle({ style: Style.Dark }); // icone bianche
        } else {
            // iOS: overlay sì, ma icone bianche e contenuto sotto gestito da safe-area
            await StatusBar.setOverlaysWebView({ overlay: false });
            await StatusBar.setStyle({ style: Style.Dark });
            // Su iOS il colore della status bar è guidato dal background della UI sottostante.
            // Se vuoi forzare una barra blu anche su iOS, serve una view blu sotto la status bar.
        }

        await StatusBar.show();

        // Alcuni emulatori cambiano flag durante l’animazione della splash.
        // Richiamiamo una passata “di sicurezza” poco dopo l’avvio (idempotente).
        setTimeout(() => {
            void this.applyBlueWhite();
        }, 300);
    }

    /** Applica BLU + icone BIANCHE in qualunque momento (idempotente) */
    async applyBlueWhite(): Promise<void> {
        /*
        if (Capacitor.getPlatform() === 'android') {
            await StatusBar.setOverlaysWebView({ overlay: false });
            await StatusBar.setBackgroundColor({ color: this.BRAND_BLUE });
        }
         */
        await StatusBar.setOverlaysWebView({ overlay: false });
        await StatusBar.setBackgroundColor({ color: this.BRAND_BLUE });
        await StatusBar.setStyle({ style: Style.Dark });
    }

    /** Applica BIANCO + icone NERE (per schermate molto chiare) */
    async applyWhiteBlack(): Promise<void> {
        if (Capacitor.getPlatform() === 'android') {
            await StatusBar.setOverlaysWebView({ overlay: false });
            await StatusBar.setBackgroundColor({ color: '#ffffff' });
        }
        await StatusBar.setStyle({ style: Style.Light });
    }
}
